// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { blockVariantOptions } from "@store/Library/Components/Toolkit/Block/variant/config";
import { getDataOptionsFieldDefinition } from "@toolkit/Framework/Common/Utilities/dataOptions";

const blockVariantField = {
    ...getDataOptionsFieldDefinition(blockVariantOptions),
    displayName: "Variant",
} as DropDownFieldDefinition<string>;

export default blockVariantField;
